// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
// Or import the input component
import DayPickerInput from 'react-day-picker/DayPickerInput';
import classNamesBind from 'classnames/bind';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment';
import moment from 'moment';

import style from '../NewFlightForm.scss';
import dateStyle from './NewFlightDate.scss';
import inputStyle from '../../../../../assets/styles/input.scss';
import icons from '../../../../../assets/styles/icons.scss';
import '../../../../../assets/styles/day-picker.css';

type Props = {
  +translateId: string;
  +locale: string;
  +data: {
    value: {
      flightDate?: number;
      object?: any;
    };
    errors?: string[];
  };
  +handleFocus: (e: Event) => void;
  +handleSelectDate: (date: Date) => void;
  +isPosting?: boolean;
};

type InputProps = {
  +translateId: string;
  +data: {
    value: {
      flightDate?: number;
      object?: any;
    };
    errors?: string[];
  };
  +handleFocus: (e: Event) => void;
  +onFocus: (e: Event) => void;
  +isPosting?: boolean;
};

const CustomNavbar = ({ previousMonth, nextMonth, onPreviousClick, onNextClick }) => {
  const styleLeft = {
    // float: 'left',
  };
  const styleRight = {
    // float: 'right',
  };
  return (
    <div className={dateStyle.navbarWrap}>
      <button type="button"
              className={dateStyle.navbarControl}
              style={styleLeft}
              onClick={() => onPreviousClick()}>
        <i className={icons.iconChevronLeftMedium}/>
      </button>
      <button type="button"
              className={dateStyle.navbarControl}
              style={styleRight}
              onClick={() => onNextClick()}>
        <i className={icons.iconChevronRightMedium}/>
      </button>
    </div>
  );
};

const Weekday = ({ weekday, className, localeUtils, locale }) => {
  const weekdayName = localeUtils.formatWeekdayLong(weekday, locale);
  return (
    <div className={classNamesBind(className, dateStyle.weekDay)} title={weekdayName}>
      {/* weekdayName.slice(0, 1) */}
      {weekdayName.slice(0, 2)}
    </div>
  );
};

const CustomCaption = ({ date, localeUtils, locale }) => {
  const monthsLabel = localeUtils.getMonths(locale);
  const month = date.getMonth();
  const year = date.getFullYear();
  return (<div className="DayPicker-Caption" role="heading">
    <h4 className={dateStyle.captionTitle}>{`${monthsLabel[month]} ${year}`}</h4>
  </div>);
};

const CustomOverlay = ({ classNames, selectedDay, children, ...props }) => (
  <div className={classNamesBind(classNames.overlayWrapper, dateStyle.overlayWrap)} {...props}>
    <div className={classNamesBind(classNames.overlay, dateStyle.overlay)}>
      {children}
    </div>
  </div>
);

class Input extends Component<InputProps, void> {
  input: HTMLInputElement;

  handleFocus(e: Event) {
    this.props.onFocus(e);
    this.props.handleFocus(e);
  }

  focus() {
    this.input.focus();
  }

  render() {
    const { data, translateId, isPosting } = this.props;
    const inputProps = update(this.props, {
      $unset: ['data', 'translateId', 'onFocus', 'handleFocus', 'isPosting'],
    });
    return (
      <FormattedMessage id={translateId}>
        {txt => [<input ref={(el: any) => (this.input = el)}
                        key="inputDate"
                        type="text"
                        name="date"
                        {...inputProps}
                        onFocus={this.handleFocus.bind(this)}
                        className={classNamesBind(inputStyle.input, style.inputDate,
                          { [inputStyle.red]: data && !!data.errors })}
                        readOnly
                        disabled={isPosting}
                        autoComplete="disabled"
                        placeholder={txt}/>,
          <i key="iconAutocomplete"
             className={icons.iconCalendarMedium}/>]}
      </FormattedMessage>
    );
  }
}

export default class NewFlightDate extends Component<Props, void> {
  render() {
    const { locale, data, translateId, handleFocus, handleSelectDate, isPosting } = this.props;
    // Why the months shouldn't be capitalized:
    // https://github.com/moment/moment/issues/2497
    return (<DayPickerInput component={Input}
                            overlayComponent={CustomOverlay}
                            formatDate={formatDate}
                            parseDate={parseDate}
                            value={data.value.object}
                            onDayChange={handleSelectDate}
                            format="LL"
                            dayPickerProps={{
                              locale,
                              localeUtils: MomentLocaleUtils,
                              captionElement: CustomCaption,
                              weekdayElement: Weekday,
                              navbarElement: CustomNavbar,
                              disabledDays: { before: moment().add(6, 'd').toDate() },
                              renderDay: (day: Date, modifiers) => {
                                return (<div className={dateStyle.day}>{day.getDate()}</div>);
                              },
                            }}
                            inputProps={{ data, translateId, handleFocus, isPosting }}
    />);
  }
};

NewFlightDate.propTypes = {
  translateId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  handleFocus: PropTypes.func.isRequired,
  handleSelectDate: PropTypes.func.isRequired,
  isPosting: PropTypes.bool,
};

Input.propTypes = {
  translateId: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  // This one is provided by the library
  onFocus: PropTypes.func.isRequired,
  // This one is our own implementation for our ui state
  handleFocus: PropTypes.func.isRequired,
  isPosting: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/new-flight/components/NewFlightForm/NewFlightDate/NewFlightDate.jsx